<template>
  <template v-for="dict in tree">
    <MenuItem :name="dict.id" :class="dict.id == selectedKey ? 'ivu-menu-item-active' : ''" :key="dict.id" v-if="(dict.title+(dict.alias ? ' ' + dict.alias : '')+(dict.code ? ' ' + dict.code : '')).includes(lastQuery)">
      <div class="children-btn" @click="loadChild($event, dict.id, dict.pid)">
        <Icon type="ios-arrow-down" size="20" v-if="opend.includes(dict.id)"/>
        <Icon type="ios-arrow-forward" size="20" v-else/>
      </div>
      <Icon type="md-list-box"  size="20"/>
      <span :style="dict.status ? '' : 'text-decoration: line-through;color: rgba(0, 0, 0, 0.25);'">
        <span v-if="(dict.title+(dict.alias ? ' ' + dict.alias : '')+(dict.code ? ' ' + dict.code : '')+(dict.sort ? ' ' + dict.sort : '')).includes(lastQuery)">
          {{ (dict.title+(dict.alias ? ' ' + dict.alias : '')+(dict.code ? ' ' + dict.code : '')+(dict.sort ? ' ' + dict.sort : '')).substring(0, (dict.title+(dict.alias ? ' ' + dict.alias : '')+(dict.code ? ' ' + dict.code : '')+(dict.sort ? ' ' + dict.sort : '')).indexOf(lastQuery)) }}
          <span style="color: #f50">{{ lastQuery }}</span>
          {{ (dict.title+(dict.alias ? ' ' + dict.alias : '')+(dict.code ? ' ' + dict.code : '')+(dict.sort ? ' ' + dict.sort : '')).substring((dict.title+(dict.alias ? ' ' + dict.alias : '')+(dict.code ? ' ' + dict.code : '')+(dict.sort ? ' ' + dict.sort : '')).indexOf(lastQuery) + lastQuery.length) }}
        </span>
        <span v-else>{{ dict.title }} {{dict.alias}} {{dict.code}} {{dict.sort}}</span>
      </span>
      <span class="pull-right"><Icon type="md-arrow-dropright" /></span>
    </MenuItem>
    <div class="child-menu-item" v-if="dict.children && opend.includes(dict.id)">
      <item :tree="dict.children" :opend="opend" :lastQuery="lastQuery" :selectedKey="selectedKey" @loadChild="loadChild"></item>
    </div>
  </template>
</template>
<script>
import item from './item'
export default {
  name: 'DictItem',
  emits: ['loadChild'],
  props: {
    tree: {
      type: Array,
      required: true
    },
    opend: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedKey: {
      type: String
    },
    lastQuery: {
      type: String
    },
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    loadChild(event, id, pid) {
      if(pid) event.stopPropagation();
      // console.log('event, id, pid => ', event, id, pid)
      this.$emit('loadChild', event, id, pid);
    },
  },
  components: {
    item
  }
}
</script>
